import type { FC } from 'react';
import { useTheme } from '@mui/material';

type iconMode = 'dark' | 'light' | 'white';

type Props = {
	width?: number;
	height?: number;
	iconMode?: iconMode;
};

export const LogoIconDticket: FC<Props> = ({
	width = 81,
	height = 40,
	iconMode = 'light',
}: Props) => {
	const theme = useTheme();
	const primaryFill =
		iconMode === 'light'
			? theme.palette.ticketing?.main ?? theme.palette.neutral[0]
			: theme.palette.neutral[0];
	const accentFill = theme.palette.ticketing?.main ?? theme.palette.neutral[0];

	const mainColor =
		iconMode === 'white' ? theme.palette.neutral[0] : primaryFill;
	const logoColor =
		iconMode === 'white' ? theme.palette.neutral[0] : accentFill;
	const logoEndColor =
		iconMode === 'light' ? theme.palette.primary.main : primaryFill;

	return (
		<svg
			width={width}
			height={height}
			viewBox="7 7 81 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_5640_10506)">
				<path
					d="M57.1422 14.246C53.1962 14.246 49.9985 17.4349 49.9985 21.3701V33.8368C49.9985 34.8193 50.7973 35.6184 51.7851 35.6184C52.7703 35.6184 53.5717 34.8218 53.5717 33.8368V27.5394C54.6224 28.145 55.842 28.4943 57.1422 28.4943C61.0883 28.4943 64.286 25.3054 64.286 21.3701C64.286 17.4349 61.0883 14.246 57.1422 14.246ZM57.1422 24.9309C55.1692 24.9309 53.5717 23.3352 53.5717 21.3701C53.5717 19.4025 55.1717 17.8093 57.1422 17.8093C59.1128 17.8093 60.7128 19.405 60.7128 21.3701C60.7128 23.3352 59.1128 24.9309 57.1422 24.9309Z"
					fill={logoEndColor}
				/>
				<path
					d="M80.7159 14.246C76.7698 14.246 73.5721 17.4349 73.5721 21.3701C73.5721 25.3054 76.7698 28.4943 80.7159 28.4943C82.0841 28.4943 83.3617 28.1098 84.4477 27.4464C84.7274 28.0646 85.3498 28.4943 86.073 28.4943C87.0583 28.4943 87.8596 27.6977 87.8596 26.7126V21.3701C87.8596 17.4349 84.6619 14.246 80.7159 14.246ZM80.7159 24.9309C78.7428 24.9309 77.1453 23.3352 77.1453 21.3701C77.1453 19.405 78.7453 17.8093 80.7159 17.8093C82.6864 17.8093 84.2864 19.405 84.2864 21.3701C84.2864 23.3377 82.6864 24.9309 80.7159 24.9309Z"
					fill={logoEndColor}
				/>
				<path
					d="M70.7142 8.90557C70.7142 7.92158 69.9148 7.1239 68.9289 7.1239C67.9429 7.1239 67.1436 7.92158 67.1436 8.90557V26.7122C67.1436 27.6962 67.9429 28.4938 68.9289 28.4938C69.9148 28.4938 70.7142 27.6962 70.7142 26.7122V8.90557Z"
					fill={logoEndColor}
				/>
				<path
					d="M40.0002 14.246C36.0541 14.246 32.8564 17.4349 32.8564 21.3701C32.8564 22.2723 32.9018 23.5312 33.3302 24.9309C34.7362 29.5195 38.1733 35.6159 39.9976 35.6159C41.822 35.6159 45.259 29.5195 46.6651 24.9309C47.0935 23.5312 47.1388 22.2723 47.1388 21.3701C47.1388 17.4349 43.9412 14.246 39.9951 14.246H40.0002ZM40.0002 24.9309C38.0271 24.9309 36.4296 23.3352 36.4296 21.3701C36.4296 19.405 38.0297 17.8093 40.0002 17.8093C41.9707 17.8093 43.5708 19.405 43.5708 21.3701C43.5708 23.3352 41.9707 24.9309 40.0002 24.9309Z"
					fill={logoColor}
				/>
				<path
					d="M20.358 20.8349C20.358 19.1638 21.7162 17.8068 23.3944 17.8068C25.0726 17.8068 26.4308 19.1613 26.4308 20.8349V26.7126C26.4308 27.6952 27.2295 28.4943 28.2173 28.4943C29.2051 28.4943 30.0039 27.6977 30.0039 26.7126V20.8349C30.0039 17.1961 27.0456 14.246 23.3969 14.246C21.4944 14.246 19.7809 15.0501 18.5765 16.3317C17.372 15.0476 15.6585 14.246 13.756 14.246C10.1073 14.246 7.14905 17.1961 7.14905 20.8349V26.7126C7.14905 27.6952 7.94783 28.4943 8.9356 28.4943C9.92338 28.4943 10.7222 27.6977 10.7222 26.7126V20.8349C10.7222 19.1638 12.0803 17.8068 13.7586 17.8068C15.4368 17.8068 16.7949 19.1613 16.7949 20.8349V26.7126C16.7949 27.6952 17.5937 28.4943 18.5815 28.4943C19.5693 28.4943 20.3681 27.6977 20.3681 26.7126V20.8349H20.358Z"
					fill={logoColor}
				/>
				<path
					d="M53.3369 44.6569C53.0749 44.8429 52.6918 44.9334 52.3013 44.9334C51.2656 44.9334 50.6609 44.4031 50.6609 43.3628V41.5635H49.983V40.586H50.6609V39.5205H51.9334V40.586H53.027V41.5635H51.9334V43.3452C51.9334 43.7196 52.1375 43.9232 52.4802 43.9232C52.6692 43.9232 52.8556 43.8654 52.9942 43.7598L53.3369 44.6544V44.6569Z"
					fill={mainColor}
				/>
				<path
					d="M53.8988 39.1718C53.8988 38.7723 54.2163 38.4632 54.69 38.4632C55.1638 38.4632 55.4813 38.7572 55.4813 39.1467C55.4813 39.5689 55.1638 39.8805 54.69 39.8805C54.2163 39.8805 53.8988 39.5714 53.8988 39.1718ZM54.055 40.4911H55.3275V44.8712H54.055V40.4911Z"
					fill={mainColor}
				/>
				<path
					d="M56.187 42.6796C56.187 41.3603 57.2075 40.4255 58.6363 40.4255C59.5585 40.4255 60.2842 40.8251 60.6043 41.5413L59.6165 42.0715C59.3796 41.6569 59.0294 41.4684 58.6287 41.4684C57.9836 41.4684 57.4772 41.9157 57.4772 42.6821C57.4772 43.4486 57.9836 43.8959 58.6287 43.8959C59.0294 43.8959 59.3796 43.7175 59.6165 43.2928L60.6043 43.8306C60.2868 44.5317 59.5585 44.9388 58.6363 44.9388C57.2075 44.9388 56.187 44.0039 56.187 42.6847V42.6796Z"
					fill={mainColor}
				/>
				<path
					d="M63.1899 43.1518L62.5776 43.7549V44.8706H61.3051V38.8295H62.5776V42.2496L64.4397 40.4906H65.9592L64.1298 42.3476L66.1204 44.8706H64.5783L63.1899 43.1543V43.1518Z"
					fill={mainColor}
				/>
				<path
					d="M70.7821 43.0394H67.4609C67.5844 43.5847 68.0481 43.9189 68.7183 43.9189C69.1845 43.9189 69.5171 43.7807 69.8195 43.4967L70.4973 44.2305C70.0891 44.6954 69.4768 44.9392 68.6856 44.9392C67.1661 44.9392 66.1783 43.9868 66.1783 42.6851C66.1783 41.3834 67.1812 40.431 68.5218 40.431C69.8623 40.431 70.8073 41.2929 70.8073 42.7027C70.8073 42.8007 70.7921 42.9389 70.7821 43.0444V43.0394ZM67.4433 42.2981H69.6053C69.5146 41.7452 69.0988 41.3859 68.5268 41.3859C67.9548 41.3859 67.5315 41.7352 67.4408 42.2981H67.4433Z"
					fill={mainColor}
				/>
				<path
					d="M74.4884 44.6569C74.2263 44.8429 73.8433 44.9334 73.4528 44.9334C72.4171 44.9334 71.8124 44.4031 71.8124 43.3628V41.5635H71.1345V40.586H71.8124V39.5205H73.0849V40.586H74.1785V41.5635H73.0849V43.3452C73.0849 43.7196 73.289 43.9232 73.6317 43.9232C73.8207 43.9232 74.0071 43.8654 74.1457 43.7598L74.4884 44.6544V44.6569Z"
					fill={mainColor}
				/>
				<path
					d="M75.0527 39.1718C75.0527 38.7723 75.3702 38.4632 75.844 38.4632C76.3177 38.4632 76.6352 38.7572 76.6352 39.1467C76.6352 39.5689 76.3177 39.8805 75.844 39.8805C75.3702 39.8805 75.0527 39.5714 75.0527 39.1718ZM75.209 40.4911H76.4815V44.8712H75.209V40.4911Z"
					fill={mainColor}
				/>
				<path
					d="M82.1564 42.3641V44.872H80.8839V42.5601C80.8839 41.8515 80.5563 41.5273 79.9944 41.5273C79.3821 41.5273 78.9411 41.9017 78.9411 42.7084V44.8745H77.6686V40.4945H78.8857V41.0071C79.2283 40.6327 79.7424 40.4291 80.3396 40.4291C81.3752 40.4291 82.1589 41.0322 82.1589 42.3666L82.1564 42.3641Z"
					fill={mainColor}
				/>
				<path
					d="M87.8863 40.4909V44.1371C87.8863 45.7655 87.0043 46.5144 85.4219 46.5144C84.5903 46.5144 83.7815 46.3108 83.2674 45.9113L83.7739 44.9991C84.1494 45.3006 84.7617 45.4966 85.3261 45.4966C86.2232 45.4966 86.6163 45.0895 86.6163 44.3005V44.112C86.2811 44.4789 85.7999 44.6573 85.2279 44.6573C84.0108 44.6573 83.0331 43.818 83.0331 42.5414C83.0331 41.2649 84.0133 40.4255 85.2279 40.4255C85.8402 40.4255 86.3467 40.6291 86.6818 41.0513V40.4909H87.8888H87.8863ZM86.6289 42.5414C86.6289 41.8981 86.1476 41.4659 85.4773 41.4659C84.807 41.4659 84.3182 41.8981 84.3182 42.5414C84.3182 43.1847 84.807 43.617 85.4773 43.617C86.1476 43.617 86.6289 43.1847 86.6289 42.5414Z"
					fill={mainColor}
				/>
			</g>
			<defs>
				<clipPath id="clip0_5640_10506">
					<rect width="95" height="52" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
